function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length,c.length);
        }
    }
    return null;
};
function setCookie(name, value, expirationSeconds) {
  var date = new Date();
  date.setTime(date.getTime()+(expirationSeconds*1000));
  document.cookie = name+"="+value+"; expires="+ date.toUTCString()+"; path=/";
};
function removeDiscountBanner() {
  setCookie('dontShowCoupon', "1", 7*24*60*60);
  document.getElementsByClassName("destaqueDoCupom")[0].setAttribute("style",null);
};
function showCupon(cupom){
    if(cupom){
        if(!getCookie("dontShowCoupon")) {
          document.getElementsByClassName("destaqueDoCupom")[0].setAttribute("style","display:block");
          document.getElementsByClassName("destaqueDoCupom-codigo")[0].innerHTML = cupom;
        }
        if(window.location.pathname=="/cart"){
            var form =  document.getElementsByClassName("formularioDoCarrinho")[0];
            var formLastChild = form.lastChild;
            var discount = document.createElement("input");
            discount.setAttribute("type", "hidden");
            discount.setAttribute("name", "discount");
            discount.setAttribute("value", cupom);
            form.insertBefore(discount,formLastChild);
        }
    }
}
(function(){
    var stringURLParameters = window.location.search.substring(1);
    var arrayURLParameters = stringURLParameters.split('&');
    var cupom = getCookie('cupom');
    if(!cupom){
        for (var i = 0; i < arrayURLParameters.length; i++){
            var arrayParameter = arrayURLParameters[i].split('=');
            if (arrayParameter[0] == 'cupom'){
                var cupomCode = arrayParameter[1];
                setCookie('cupom', cupomCode, 7*24*60*60);
            }
        }
        cupom = getCookie('cupom');
    }
  
    if(cupom == "DIA_DO_LIVRO" || cupom == "SEMANADAPROGRAMACAO2020" || cupom == "10ANOSCDC"){
          document.cookie = "cupom=expirado; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
          cupom = undefined;
    }
  	showCupon(cupom);
})();
